import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_ORDERSFROMCHEMIST_INIT_ACTION,
  FETCH_ORDERSFROMCHEMIST_SUCCESS_ACTION,
  FETCH_ORDERSFROMCHEMIST_FAIL_ACTION,
  FETCH_NORMALPROCESSEDORDERS_INIT_ACTION,
  FETCH_NORMALPROCESSEDORDERS_SUCCESS_ACTION,
  FETCH_NORMALPROCESSEDORDERS_FAIL_ACTION,
  FETCH_DELIVEREDNORMALORDERS_INIT_ACTION,
  FETCH_DELIVEREDNORMALORDERS_SUCCESS_ACTION,
  FETCH_DELIVEREDNORMALORDERS_FAIL_ACTION,
  FETCH_URGENT_ORDERS_INIT_ACTION,
  FETCH_URGENT_ORDERS_SUCCESS_ACTION,
  FETCH_URGENT_ORDERS_FAIL_ACTION,
  FETCH_PROCESSEDURGENTORDERS_INIT_ACTION,
  FETCH_PROCESSEDURGENTORDERS_SUCCESS_ACTION,
  FETCH_PROCESSEDURGENTORDERS_FAIL_ACTION,
  FETCH_DELIVEREDURGENTORDERS_INIT_ACTION,
  FETCH_DELIVEREDURGENTORDERS_SUCCESS_ACTION,
  FETCH_DELIVEREDURGENTORDERS_FAIL_ACTION,
  FETCH_RETURNS_INIT_ACTION,
  FETCH_RETURNS_SUCCESS_ACTION,
  FETCH_RETURNS_FAIL_ACTION,
  FETCH_CREDITNOTES_INIT_ACTION,
  FETCH_CREDITNOTES_SUCCESS_ACTION,
  FETCH_CREDITNOTES_FAIL_ACTION,
  FETCH_SUPPORTTICKETS_INIT_ACTION,
  FETCH_SUPPORTTICKETS_SUCCESS_ACTION,
  FETCH_SUPPORTTICKETS_FAIL_ACTION,
  FETCH_CANCELNORMALORDERS_INIT_ACTION,
  FETCH_CANCELNORMALORDERS_SUCCESS_ACTION,
  FETCH_CANCELNORMALORDERS_FAIL_ACTION,
  FETCH_CANCELURGENTORDERS_INIT_ACTION,
  FETCH_CANCELURGENTORDERS_SUCCESS_ACTION,
  FETCH_CANCELURGENTORDERS_FAIL_ACTION,
  FETCH_EXPIRYRETURNS_INIT_ACTION,
  FETCH_EXPIRYRETURNS_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNS_FAIL_ACTION,
} from "./action";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";

var history = createBrowserHistory();

function* fetchOrdersfromChemist() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=created,confirm`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ORDERSFROMCHEMIST_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_ORDERSFROMCHEMIST_FAIL_ACTION, error: err });
    }
  }
}

function* processednormalOrdersList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=accepted`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_NORMALPROCESSEDORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_NORMALPROCESSEDORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* deliverednormalOrdersList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=delivered,shipmentReady`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_DELIVEREDNORMALORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DELIVEREDNORMALORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchUrgentOrders(value) {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  let pageno = value.value === undefined ? 1 : value.value;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=urgent&orderType=purchase&status=created,confirm&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      // console.log(resJSON);

      yield put({
        type: FETCH_URGENT_ORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_URGENT_ORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* processedurgentOrdersList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=urgent&orderType=purchase&status=accepted`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_PROCESSEDURGENTORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PROCESSEDURGENTORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* deliveredurgentOrdersList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=urgent&orderType=purchase&status=delivered,shipmentReady`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_DELIVEREDURGENTORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DELIVEREDURGENTORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* orderReturnList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderTo=${distID}&orderType=return`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_RETURNS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_RETURNS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchCreditNotes(value) {
  const token = localStorage.getItem("token");
  const distId = localStorage.getItem("distributorId");

  try {
    const res = yield fetch(`${appConfig.ip}/creditNotes?crdtFrom=${distId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CREDITNOTES_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CREDITNOTES_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* supportTickets() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(`${appConfig.ip}/support?userId=${distID}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log(res.url);
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      // console.log(resJSON);

      yield put({
        type: FETCH_SUPPORTTICKETS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUPPORTTICKETS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* cancellednormalOrdersList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=normal&orderType=purchase&status=cancelled,rejected`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_CANCELNORMALORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CANCELNORMALORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* cancelledurgentOrdersList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=chemist&orderTo=${distID}&orderTrk=urgent&orderType=purchase&status=cancelled,rejected`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_CANCELURGENTORDERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CANCELURGENTORDERS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* expiryReturnList() {
  const token = localStorage.getItem("token");
  const distID = JSON.parse(localStorage.getItem("userDetails")).id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderTo=${distID}&orderType=expiryReturn`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_EXPIRYRETURNS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_EXPIRYRETURNS_FAIL_ACTION,
        error: err,
      });
    }
  }
}

export function* DashboardActionWatcher() {
  yield takeEvery(FETCH_ORDERSFROMCHEMIST_INIT_ACTION, fetchOrdersfromChemist);
  yield takeEvery(
    FETCH_NORMALPROCESSEDORDERS_INIT_ACTION,
    processednormalOrdersList,
  );
  yield takeEvery(
    FETCH_DELIVEREDNORMALORDERS_INIT_ACTION,
    deliverednormalOrdersList,
  );
  yield takeEvery(FETCH_URGENT_ORDERS_INIT_ACTION, fetchUrgentOrders);
  yield takeEvery(
    FETCH_PROCESSEDURGENTORDERS_INIT_ACTION,
    processedurgentOrdersList,
  );
  yield takeEvery(
    FETCH_DELIVEREDURGENTORDERS_INIT_ACTION,
    deliveredurgentOrdersList,
  );
  yield takeEvery(FETCH_RETURNS_INIT_ACTION, orderReturnList);
  yield takeEvery(FETCH_CREDITNOTES_INIT_ACTION, fetchCreditNotes);
  yield takeEvery(FETCH_SUPPORTTICKETS_INIT_ACTION, supportTickets);
  yield takeEvery(
    FETCH_CANCELNORMALORDERS_INIT_ACTION,
    cancellednormalOrdersList,
  );
  yield takeEvery(
    FETCH_CANCELURGENTORDERS_INIT_ACTION,
    cancelledurgentOrdersList,
  );
  yield takeEvery(FETCH_EXPIRYRETURNS_INIT_ACTION, expiryReturnList);
}
